module.exports = __webpack_public_path__ + "static/media/insert-emoji-icon.61b155c8.svg";